const i18n = require('i18n');

export default [
  {
    title: i18n('Interactive. Personal. Training.').context('User is involved. Training is customized to the user. Exercising.').toString(),
    videoBg: 'https://player.vimeo.com/external/467808155.hd.mp4?s=5cc139c6c0c4edb06b5f5097c0afccc62ac40b66&profile_id=175',
    mobileVideoBg: 'https://player.vimeo.com/external/467808155.sd.mp4?s=63bd9e2443ecc6154dac239f09d8221c013b4829&profile_id=164',
    backgroundImage: '/marketing/homepage/img/slide-1.jpg',
    mobileBackgroundImage: '/marketing/homepage/img/slide-1.jpg',
    ctaLabel: i18n('Start for just $15').context('Signup for iFit with a starting cost of $15.').toString(),
    ctaUrl: '/register'
  },
  {
    title: i18n(' Not just connected–it’s interactive fitness').context('iFit membership has virtual training.' ).toString(),
    videoBg: 'https://player.vimeo.com/external/356777564.hd.mp4?s=6662a817076f787c49f8efc0374716a0c843ddf1&profile_id=175',
    mobileVideoBg: 'https://player.vimeo.com/external/356777564.sd.mp4?s=855ea1e06e9d287001edb88eb4a000518fbb2495&profile_id=164',
    backgroundImage: '/marketing/homepage/img/slide-2.jpg',
    mobileBackgroundImage: '/marketing/homepage/img/slide-2.jpg',
    ctaLabel: i18n('Start for just $15').context('Signup for iFit with a starting cost of $15.').toString(),
    ctaUrl: '/register'
  }
];
